module.exports = __webpack_public_path__ + "static/media/multi-currency-1.b07779c4.png";